import { createSlice } from '@reduxjs/toolkit';

const initAuthMessage = { isSuccess: false, message: '' };

const invitationSlice = createSlice({
  name: 'invitation',
  initialState: {
    employeeVo: {},
    incorrectOTPcount: 0,
    authMessage: initAuthMessage,
    linkInvtCd: '',
    duplicateIdCheck: false,
    isOtpSuccess: false,
    otpCheckMessage: null,
    isSendOtp: false,
    isCreateAccount: false,
    linkFail: false,
    svcType: [],
  },
  reducers: {
    // 아이디 중복 체크
    initAuthentication: state => {
      state.authMessage = initAuthMessage;
      state.duplicateIdCheck = false;
      state.isOtpSuccess = false;
      state.isSendOtp = false;
      state.employeeVo.userId = '';
    },
    duplicateIdCheck: state => {
      state.authMessage = initAuthMessage;
      state.employeeVo.userId = '';
      state.duplicateIdCheck = false;
      state.isOtpSuccess = false;
      state.isSendOtp = false;
    },
    duplicateIdCheckSuccess: (state, { payload }) => {
      state.duplicateIdCheck = true;
      state.employeeVo.userId = payload.query;
      state.authMessage.isSuccess = true;
      state.authMessage.message = 'MB_M_EMAIL_VALIDATED';
    },
    duplicateIdCheckFail: (state, { payload }) => {
      state.duplicateIdCheck = false;
      state.employeeVo.userId = '';
      state.authMessage.isSuccess = false;
      state.authMessage.message = payload.errorCode;
    },
    setAuthMessage: (state, { payload }) => {
      state.authMessage.isSuccess = false;
      state.authMessage.message = payload.message;
    },
    // otp 발송
    createOtp: state => {
      state.isSendOtp = false;
      state.isOtpSuccess = false;
    },
    createOtpSuccess: state => {
      state.isSendOtp = true;
      state.authMessage.isSuccess = true;
      state.authMessage.message = 'MB_T_SEND_OTP_TO_MAIL';
    },
    createOtpFail: (state, { payload }) => {
      state.isSendOtp = false;
      state.authMessage.isSuccess = false;
      state.authMessage.message = payload.errorCode;
    },
    checkOtp: state => {
      state.isOtpSuccess = false;
    },
    checkOtpSuccess: state => {
      state.isOtpSuccess = true;
      state.otpCheckMessage = null;
    },
    checkOtpFail: (state, { payload }) => {
      state.incorrectOTPcount += 1;
      state.otpCheckMessage = payload;
      state.isOtpSuccess = false;
    },
    resetCheckOTPcount: state => {
      state.incorrectOTPcount = 0;
      state.otpCheckMessage = null;
      state.isOtpSuccess = false;
      state.isSendOtp = false;
    },
    getInviteLink: () => {},
    getInviteLinkSuccess: (state, { payload }) => {
      state.employeeVo = payload;
      state.svcType = payload.svcType;
      state.linkFail = false;
    },
    getInviteLinkFail: state => {
      state.linkFail = true;
    },
    setInviteLink: (state, { payload }) => {
      state.linkInvtCd = payload;
    },
    setSendOtp: (state, { payload }) => {
      state.isSendOtp = payload;
    },
    createInviteEmp: () => {},
    createInviteEmpSuccess: (state, { payload }) => {
      state.isCreateAccount = payload;
    },
  },
});

export const {
  initAuthentication,
  duplicateIdCheck,
  duplicateIdCheckSuccess,
  duplicateIdCheckFail,
  getInviteLink,
  getInviteLinkSuccess,
  getInviteLinkFail,
  setInviteLink,
  setAuthMessage,
  setSendOtp,
  checkOtp,
  checkOtpSuccess,
  checkOtpFail,
  createOtp,
  createOtpSuccess,
  createOtpFail,
  resetCheckOTPcount,
  createInviteEmp,
  createInviteEmpSuccess,
} = invitationSlice.actions;
export default invitationSlice.reducer;
